import DatePicker from "react-datepicker";
const KDatePicker = (props) => {
  const { value, placeholder, maxDate, minDate, onChange, label, labelClass } = props;
  return (
    <div className="form-group">
      <label for={`date-${label}`} className={labelClass}>{label}</label>
      <DatePicker
        className="form-control bg-gray"
        selected={value}
        dateFormat="dd-MM-yy"
        placeholderText={placeholder}
        maxDate={maxDate}
        minDate={minDate}
        onChange={onChange}
        onKeyDown={(e) => e.preventDefault()}
        showYearDropdown
        scrollableYearDropdown
        yearDropdownItemNumber={1000}
        showMonthDropdown
      />
    </div>
  );
};

export default KDatePicker;
